/**
 * Run layout-affecting work after ResizeObserver delivery completes.
 * Mutating scroll position or element size inside an RO callback can
 * re-enter observation in the same frame and trigger:
 * "ResizeObserver loop completed with undelivered notifications."
 */
let pendingFrame = 0
const pending = new Set<() => void>()

export function scheduleAfterResizeObserver(callback: () => void): void {
    pending.add(callback)
    if (pendingFrame) return
    pendingFrame = requestAnimationFrame(() => {
        pendingFrame = 0
        const batch = [...pending]
        pending.clear()
        for (const fn of batch) {
            fn()
        }
    })
}

export function isBenignResizeObserverLoopError(message: unknown): boolean {
    if (typeof message !== 'string') return false
    return message.includes('ResizeObserver loop')
}
